<button
  (click)="onClick($event)"
  [ngClass]="{ 'button-hover': !disable && buttonHover, disabled: disable }"
  [ngStyle]="ngStyle">
  <ng-content></ng-content>
</button>
